/**
 * @generated SignedSource<<015ad428b55af155c229ab031c42c4bc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileCollectionNav_viewer$data = {
  readonly publicProfile: {
    readonly username: string | null;
  } | null;
  readonly " $fragmentType": "NftProfileCollectionNav_viewer";
};
export type NftProfileCollectionNav_viewer$key = {
  readonly " $data"?: NftProfileCollectionNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileCollectionNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "username"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileCollectionNav_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "username",
          "variableName": "username"
        }
      ],
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2da60ff54b91e5142faa9e070811d6e1";

export default node;
